import { REQUEST_SENSORS, RECEIVE_SENSORS, FAILED_SENSORS } from "./../actions/sensorsActions";

export const sensors = (
  state = {
    isFetching: false,
    loadError: false,
    items: [],
    filters: [],
  },
  action
) => {
  switch (action.type) {
    case REQUEST_SENSORS:
      return Object.assign({}, state, {
        loadError: false,
        isFetching: true,
      });
    case RECEIVE_SENSORS:
      return Object.assign({}, state, {
        isFetching: false,
        items: action.items,
        filters: action.filters,
      });
    case FAILED_SENSORS:
      return Object.assign({}, state, {
        isFetching: false,
        loadError: true,
      });
    default:
      return state;
  }
};
